







import { Component, Prop, Vue, Watch, Inject } from 'vue-property-decorator';
import ClassItemRate from '../../../models/interfaces/ClassItemRate';
import Emoticons from '../../ScoreInput/Emoticons.vue';
import ClassItem from '../../../models/interfaces/ClassItem';

import { Type as IndicatorsType } from '@solucx/indicators';
import { ClassRatingLike } from '../../../utils/ClassRatingLike';

@Component({ components: { Emoticons } })
export default class ClassESAT extends Vue {
  @Prop({ required: true })
  public readonly item!: ClassItem;

  @Prop({ required: true })
  public readonly value!: ClassItemRate;

  @Watch('value.score')
  public updateLike(score: number) {
    this.value.like = ClassRatingLike.getRatingLike(score, IndicatorsType.ESAT);
    this.$emit('input', this.value);
  }
}
